export default __webpack_public_path__ + "static/media/2541.c5c0bce0.png";